import styled from '@emotion/styled'
import { MenuList } from '@mui/material'

export const CustomMenuList = styled(MenuList)({
  '& .MuiMenuItem-root': {
    color: '#06004A',
    transition: 'background-color 0.3s ease, color 0.3s ease',
    '&:hover': {
      backgroundColor: '#1705E5',
      color: '#fff',
    },
  },
})
